var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravelSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_3531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4785 14.6172H24.3535V23.3672C24.3535 24.8171 23.1784 25.9922 21.7285 25.9922H7.72852C6.27864 25.9922 5.10352 24.8171 5.10352 23.3672V14.6172H12.9785V15.4922C12.9785 15.9752 13.3705 16.3672 13.8535 16.3672H15.6035C16.0865 16.3672 16.4785 15.9752 16.4785 15.4922V14.6172ZM15.6035 12.8672H13.8535V15.4922H15.6035V12.8672ZM24.3535 11.1172V13.7422H16.4785V12.8672C16.4785 12.3842 16.0865 11.9922 15.6035 11.9922H13.8535C13.3705 11.9922 12.9785 12.3842 12.9785 12.8672V13.7422H5.10352V11.1172C5.10352 9.66731 6.27864 8.49219 7.72852 8.49219H11.2285V4.11719C10.7455 4.11719 10.3535 3.72519 10.3535 3.24219C10.3535 1.79231 11.5286 0.617188 12.9785 0.617188H16.4785C17.9284 0.617188 19.1035 1.79231 19.1035 3.24219C19.1035 3.72519 18.7115 4.11719 18.2285 4.11719V8.49219H21.7285C23.1784 8.49219 24.3535 9.66731 24.3535 11.1172ZM17.3535 4.11719C16.8705 4.11719 16.4785 3.72519 16.4785 3.24219H12.9785C12.9785 3.72519 12.5865 4.11719 12.1035 4.11719V8.49219H17.3535V4.11719ZM19.9785 28.6172C20.9454 28.6172 21.7285 27.8341 21.7285 26.8672H18.2285C18.2285 27.8341 19.0116 28.6172 19.9785 28.6172ZM9.47852 28.6172C10.4454 28.6172 11.2285 27.8341 11.2285 26.8672H7.72852C7.72852 27.8341 8.51164 28.6172 9.47852 28.6172Z",
    fill: "#570987"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_3531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.728516 0.617188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelSvgrepoCom);
export default __webpack_public_path__ + "static/media/travel-svgrepo-com.b67d8905e8e35609450d4b4d936e7da3.svg";
export { ForwardRef as ReactComponent };